import React from "react";
import Chip from "@mui/material/Chip";

const STATUS_COLOR = {
  draft:     "default",
  published: "success",
  scheduled: "warning",
  archived:  "error",
};

export function PostStatusChip({ status }) {
  return (
    <Chip
      label={status ? status.charAt(0).toUpperCase() + status.slice(1) : "—"}
      color={STATUS_COLOR[status] || "default"}
      size="small"
    />
  );
}
